import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { PageDetailsComponent } from '@client/app/components/pagedetails/details/page-details.component';

@Component({
    selector: 'url-title',
    standalone: false,
    template: `
        <div class="page-title">
            <div class="url-title-link outer-b-smurf text-nowrap text-ellipsis">
                <a (click)="goToFunction()"
                   [attr.data-test]="'page-title-link-' + getTitle()"
                   tabindex="0"
                   [attr.aria-label]="translateService.getString('Open details')"
                   role="button"
                   (keydown)="onGoToFunctionKeydown($event)"
                   *ngIf="isFunction && !page"
                   class="cursor-pointer"
                   e2e="url-title-link-go-to"
                   [title]="getTitle()">
                   {{ getTitle() }}
                </a>
                <a (click)="openPageDetails()"
                   (keydown)="onPageDetailsKeydown($event)"
                   *ngIf="page"
                   class="cursor-pointer"
                   tabindex="0"
                   [attr.aria-label]="translateService.getString('Open page details')"
                   role="button"
                   e2e="url-title-link-page-details">
                   {{ getTitle() }}
                </a>
                <a [uiSref]="urlTo"
                   *ngIf="!isFunction && !page && active"
                   role="button"
                   [attr.aria-label]="translateService.getString('Open details')"
                   e2e="url-title-link-url-to"
                   [title]="getTitle()"
                   tabindex="0">
                    {{ getTitle() }}
                </a>
                <a [href]="url"
                   target="_blank"
                   tabindex="0"
                   role="button"
                   class="cursor-pointer"
                   *ngIf="!active && !page && !isFunction"
                   [title]="getTitle()"
                   e2e="url-title-link-no-url">{{ getTitle() }}</a>
            </div>
            <div class="tooltip_url text-nowrap text-ellipsis">
                <a [href]="url"
                   target="_blank"
                   aria-describedby="linkOpensInNewTab"
                   title="Go to page">
                   <span class="fas icon fa-external-link-alt"></span>
                   <span class="sr-only">{{url}}</span>
                </a>
                <span class="link-tooltip" [title]="url">&nbsp;{{ url }}</span>
            </div>
        </div>
    `,
})
export class UrlTitleComponent implements OnInit {
    @Input() title?: string | undefined;
    @Input() url?: string | undefined;
    @Input() urlTo: string = '';
    @Input() active?: boolean | undefined;
    @Input() page?: any;
    @Input() model?: any;
    @Input() missingTitleText?: string | undefined;

    @Output() goTo = new EventEmitter<void>();

    isFunction = false;

    constructor (
        private stateService: StateService,
        public translateService: TranslateService,
        private monDialog: MonDialog,
    ) {}

    ngOnInit () {
        this.isFunction = false;
        this.active = this.active !== undefined ? this.active : true;
        if (this.urlTo === undefined) {
            this.urlTo = '';
        }
        if (this.goTo.observers.length > 0) {
            this.isFunction = true;
        }
    }

    onGoToFunctionKeydown ($event) {
        if ($event.key === 'Enter' || $event.key === ' ') {
            this.goToFunction();
        }
    }

    onPageDetailsKeydown ($event) {
        if ($event.key === 'Enter' || $event.key === ' ') {
            this.openPageDetails();
        }
    }

    openPageDetails () {
        const params = {
            body: PageDetailsComponent,
            size: 'fw',
            classes: 'page-details-app',
            data: { page: this.page },
        };
        this.monDialog.create(params, null, null);
    }

    getTitle (): string {
        if (this.title) {
            return this.title;
        }

        if (this.missingTitleText !== undefined) {
            return this.missingTitleText;
        }

        return '(No title found)';
    }

    goToFunction () {
        if (this.goTo.observers.length > 0) {
            this.goTo.emit();
        }
    }
}
